import { render } from "./StreamCardBadges.vue?vue&type=template&id=1e04a894"
import script from "./StreamCardBadges.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamCardBadges.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamCard/StreamCardBadges.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e04a894"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e04a894', __exports__)) {
    api.reload('1e04a894', __exports__)
  }
  
  module.hot.accept("./StreamCardBadges.vue?vue&type=template&id=1e04a894", () => {
    api.rerender('1e04a894', render)
  })

}


export default __exports__